import { ThreadActivityLog } from "@/app/Threads/GraphQL/threadActivityQuery";
import { ActivityIcon } from "lucide-react";
import { useTranslations } from "use-intl";
import dayjs from "dayjs";

export function ThreadActivityRow({ log }: { log: ThreadActivityLog }) {
  const t = useTranslations("thread.activity");

  return (
    <div className="flex justify-center">
      <span className="inline-flex max-w-md items-center gap-1.5 rounded-2xl bg-gray-100 px-3 py-1 text-xs text-gray-500">
        <ActivityIcon className="size-3.5 shrink-0 text-gray-400" />
        <span>
          <span className="font-medium text-gray-700">
            {log.causer?.name ?? t("system")}
          </span>{" "}
          {log.description}
        </span>
        <span className="shrink-0 text-gray-400">
          {dayjs.utc(log.created_at).local().format("h:mm A")}
        </span>
      </span>
    </div>
  );
}
